// import React, { useState, useMemo } from "react";
// import moment from "moment";
// import { Download, Users, Clock, DollarSign, CheckCircle2 } from "lucide-react";
// import Layout from "../../components/layout/Layout";
// import { Button } from "../../components/ui/button";
// import MainHeading from "../../components/common/MainHeading";
// import CommonFilter, { type IFilter } from "../../components/common/CommonFilter";
// import CommonTable, { type TableColumn } from "../../components/common/CommonTable";
// import TablePagination from "../../components/common/TablePagination";
// import type { IPageInfo } from "@/interface/common.interface";

// // ─── Types ──────────────────────────────────────────────────────────────

// interface IPunchData {
//   punchIn?: string;
//   punchOut?: string;
// }

// interface IEmployeeDailyWage {
//   id: string;
//   name: string;
//   shift: string;          // <-- added shift: Day, Night, or Afternoon
//   site: string;
//   hourlyRate: number;
//   days: Record<number, IPunchData>;
// }

// type WageStatus = "Paid" | "Due" | "Absent";

// interface IWageRow {
//   key: string;
//   emp: IEmployeeDailyWage;
//   date: moment.Moment;
//   dayNum: number;
//   punchIn?: string;
//   punchOut?: string;
//   hours: number;
//   wage: number;
//   status: WageStatus;
// }

// // ─── Helpers ─────────────────────────────────────────────────────────────

// const calculateHours = (punchIn?: string, punchOut?: string): number => {
//   if (!punchIn || !punchOut) return 0;
//   const start = moment(punchIn, "hh:mm A");
//   const end = moment(punchOut, "hh:mm A");
//   const duration = moment.duration(end.diff(start));
//   const hours = duration.asHours();
//   return Math.round(hours * 10) / 10;
// };

// const formatPunchTime = (time?: string): string => {
//   if (!time) return "";
//   return moment(time, "hh:mm A").format("HH:mm");
// };

// const getStatus = (punchIn?: string, punchOut?: string): WageStatus => {
//   if (punchIn && punchOut) return "Paid";
//   if (punchIn || punchOut) return "Due";
//   return "Absent";
// };

// const statusStyles: Record<WageStatus, string> = {
//   Paid: "bg-emerald-600 text-white",
//   Due: "bg-amber-100 text-amber-800",
//   Absent: "bg-slate-900 text-white",
// };

// const avatarPalette = [
//   "bg-rose-100 text-rose-700",
//   "bg-indigo-100 text-indigo-700",
//   "bg-amber-100 text-amber-800",
//   "bg-emerald-100 text-emerald-700",
//   "bg-sky-100 text-sky-700",
//   "bg-violet-100 text-violet-700",
//   "bg-teal-100 text-teal-700",
//   "bg-orange-100 text-orange-700",
// ];

// // ─── Mock Data ──────────────────────────────────────────────────────────

// // Each employee now has a 'shift' property.
// const initialEmployeesData: IEmployeeDailyWage[] = [
//   {
//     id: "E001",
//     name: "Rajesh Kumar",
//     shift: "Day",
//     site: "Site A",
//     hourlyRate: 85,
//     days: {
//       1: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
//       2: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       3: { punchIn: "7:45 AM" },
//       4: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
//       5: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
//       6: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
//       7: {},
//       8: { punchIn: "8:10 AM", punchOut: "4:20 PM" },
//       9: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
//       10: { punchIn: "8:00 AM" },
//       11: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
//       12: { punchIn: "7:50 AM", punchOut: "4:10 PM" },
//       13: {},
//       14: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
//       15: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
//     },
//   },
//   {
//     id: "E002",
//     name: "Sunita Devi",
//     shift: "Afternoon",
//     site: "Site B",
//     hourlyRate: 65,
//     days: {
//       1: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
//       2: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
//       3: {},
//       4: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
//       5: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
//       6: { punchIn: "8:30 AM" },
//       7: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
//       8: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
//       9: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
//       10: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
//       11: {},
//       12: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
//       13: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
//       14: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
//       15: { punchIn: "8:30 AM" },
//     },
//   },
//   {
//     id: "E003",
//     name: "Arvind Singh",
//     shift: "Night",
//     site: "Site A",
//     hourlyRate: 110,
//     days: {
//       1: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       2: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       3: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       4: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       5: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       6: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       7: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       8: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       9: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       10: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       11: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       12: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       13: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       14: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//       15: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
//     },
//   },
//   {
//     id: "E004",
//     name: "Priya Sharma",
//     shift: "Day",
//     site: "Site C",
//     hourlyRate: 95,
//     days: {
//       1: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       2: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       3: {},
//       4: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       5: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       6: {},
//       7: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       8: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       9: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       10: { punchIn: "8:15 AM" },
//       11: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       12: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       13: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       14: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
//       15: {},
//     },
//   },
//   {
//     id: "E005",
//     name: "Vikram Patel",
//     shift: "Afternoon",
//     site: "Site B",
//     hourlyRate: 80,
//     days: {
//       1: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//       2: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//       3: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//       4: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//       5: {},
//       6: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//       7: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//       8: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//       9: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//       10: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//       11: {},
//       12: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//       13: { punchIn: "8:30 AM" },
//       14: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//       15: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
//     },
//   },
//   {
//     id: "E006",
//     name: "Anita Reddy",
//     shift: "Night",
//     site: "Site C",
//     hourlyRate: 60,
//     days: {
//       1: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//       2: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//       3: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//       4: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//       5: { punchIn: "9:00 AM" },
//       6: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//       7: {},
//       8: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//       9: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//       10: {},
//       11: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//       12: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//       13: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//       14: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//       15: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
//     },
//   },
//   {
//     id: "E007",
//     name: "Manoj Kumar",
//     shift: "Day",
//     site: "Site A",
//     hourlyRate: 100,
//     days: {
//       1: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       2: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       3: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       4: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       5: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       6: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       7: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       8: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       9: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       10: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       11: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       12: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       13: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       14: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//       15: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
//     },
//   },
//   {
//     id: "E008",
//     name: "Sneha Patel",
//     shift: "Afternoon",
//     site: "Site B",
//     hourlyRate: 90,
//     days: {
//       1: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       2: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       3: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       4: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       5: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       6: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       7: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       8: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       9: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       10: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       11: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       12: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       13: {},
//       14: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//       15: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
//     },
//   },
//   {
//     id: "E009",
//     name: "Ravi Singh",
//     shift: "Night",
//     site: "Site C",
//     hourlyRate: 85,
//     days: {
//       1: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//       2: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//       3: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//       4: {},
//       5: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//       6: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//       7: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//       8: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//       9: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//       10: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//       11: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//       12: { punchIn: "8:20 AM" },
//       13: {},
//       14: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//       15: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
//     },
//   },
//   {
//     id: "E010",
//     name: "Geeta Sharma",
//     shift: "Day",
//     site: "Site A",
//     hourlyRate: 120,
//     days: {
//       1: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       2: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       3: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       4: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       5: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       6: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       7: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       8: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       9: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       10: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       11: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       12: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       13: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//       14: {},
//       15: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
//     },
//   },
// ];

// // ─── Filter / Sort options ─────────────────────────────────────────────

// const statusFilterOptions = [
//   { label: "All", value: "" },
//   { label: "Paid", value: "Paid" },
//   { label: "Due", value: "Due" },
//   { label: "Absent", value: "Absent" },
// ];

// const sortOptions = [
//   { label: "Employee", value: "name" },
//   { label: "Date", value: "date" },
//   { label: "Hours", value: "hours" },
//   { label: "Wage", value: "wage" },
//   { label: "Status", value: "status" },
//   { label: "Shift", value: "shift" }, // added sort by shift
// ];

// // ─── Component ──────────────────────────────────────────────────────────

// const WageReport: React.FC = () => {
//   const [filter, setFilter] = useState<IFilter>({
//     search: "",
//     filter: "",       // status filter
//     sort: "date",
//     site: "All",      // site filter
//     shift: "All",     // shift filter (added)
//     startDate: moment().startOf("month").format("YYYY-MM-DD"),
//     endDate: moment().endOf("month").format("YYYY-MM-DD"),
//   });

//   const [paginationData, setPaginationData] = useState<IPageInfo>({
//     currentPage: 1,
//     pageSize: 10,
//     total: 0,
//     totalPages: 0,
//   });

//   // ─── Build flattened rows ─────────────────────────────────────────────

//   const rows = useMemo(() => {
//     const start = moment(filter.startDate);
//     const end = moment(filter.endDate);
//     const days: moment.Moment[] = [];
//     const cursor = start.clone();
//     while (cursor.isSameOrBefore(end, "day") && days.length < 62) {
//       days.push(cursor.clone());
//       cursor.add(1, "day");
//     }

//     const records: IWageRow[] = [];

//     initialEmployeesData.forEach((emp) => {
//       days.forEach((date) => {
//         const dayNum = date.date();
//         const dayData = emp.days[dayNum] || {};
//         const hours = calculateHours(dayData.punchIn, dayData.punchOut);
//         const wage = Math.round(hours * emp.hourlyRate);
//         const status = getStatus(dayData.punchIn, dayData.punchOut);

//         records.push({
//           key: `${emp.id}-${date.format("YYYY-MM-DD")}`,
//           emp,
//           date,
//           dayNum,
//           punchIn: dayData.punchIn,
//           punchOut: dayData.punchOut,
//           hours,
//           wage,
//           status,
//         });
//       });
//     });

//     return records;
//   }, [filter.startDate, filter.endDate]);

//   // ─── Filter & Sort ──────────────────────────────────────────────────

//   const filteredRows = useMemo(() => {
//     const search = (filter.search || "").toLowerCase();
//     const siteFilter = filter.site || "All";
//     const shiftFilter = filter.shift || "All";

//     let result = rows.filter((row) => {
//       const matchesSearch =
//         !search ||
//         row.emp.name.toLowerCase().includes(search) ||
//         row.emp.id.toLowerCase().includes(search);
//       const matchesStatus = !filter.filter || row.status === filter.filter;
//       const matchesSite = siteFilter === "All" || row.emp.site === siteFilter;
//       const matchesShift = shiftFilter === "All" || row.emp.shift === shiftFilter;
//       return matchesSearch && matchesStatus && matchesSite && matchesShift;
//     });

//     const sortKey = filter.sort || "date";
//     result = [...result].sort((a, b) => {
//       if (sortKey === "name") return a.emp.name.localeCompare(b.emp.name);
//       if (sortKey === "date") return a.date.valueOf() - b.date.valueOf();
//       if (sortKey === "hours") return b.hours - a.hours;
//       if (sortKey === "wage") return b.wage - a.wage;
//       if (sortKey === "status") return a.status.localeCompare(b.status);
//       if (sortKey === "shift") return a.emp.shift.localeCompare(b.emp.shift);
//       return 0;
//     });

//     return result;
//   }, [rows, filter.search, filter.filter, filter.sort, filter.site, filter.shift]);

//   // ─── Global Stats ──────────────────────────────────────────────────

//   const globalStats = useMemo(() => {
//     let totalHours = 0;
//     let totalWage = 0;
//     let paidDays = 0;
//     let dueDays = 0;
//     let absentDays = 0;

//     filteredRows.forEach((row) => {
//       if (row.status === "Paid") {
//         paidDays++;
//         totalHours += row.hours;
//         totalWage += row.wage;
//       } else if (row.status === "Due") {
//         dueDays++;
//         totalHours += row.hours;
//         totalWage += row.wage;
//       } else {
//         absentDays++;
//       }
//     });

//     return {
//       employees: new Set(filteredRows.map((r) => r.emp.id)).size,
//       hours: Math.round(totalHours * 10) / 10,
//       paidDays,
//       dueDays,
//       payable: Math.round(totalWage),
//     };
//   }, [filteredRows]);

//   // ─── Pagination ──────────────────────────────────────────────────────

//   const totalPages = Math.max(1, Math.ceil(filteredRows.length / paginationData.pageSize));
//   const currentPage = Math.min(paginationData.currentPage, totalPages);
//   const pagedRows = filteredRows.slice(
//     (currentPage - 1) * paginationData.pageSize,
//     currentPage * paginationData.pageSize,
//   );

//   const tablePaginationData: IPageInfo = {
//     ...paginationData,
//     currentPage,
//     total: filteredRows.length,
//     totalPages,
//   };

//   // ─── Handlers ────────────────────────────────────────────────────────

//   const handleSearchChange = (value: string) => {
//     setFilter((prev) => ({ ...prev, search: value }));
//     setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleFilterChange = (value: string, name: string) => {
//     setFilter((prev) => ({ ...prev, [name]: value }));
//     setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleDateRangeChange = (start: string, end: string) => {
//     setFilter((prev) => ({
//       ...prev,
//       startDate: start || moment().startOf("month").format("YYYY-MM-DD"),
//       endDate: end || moment().endOf("month").format("YYYY-MM-DD"),
//     }));
//     setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
//   };

//   const handleChangePageSize = (value: number) => {
//     setPaginationData((prev) => ({ ...prev, pageSize: value, currentPage: 1 }));
//   };

//   // ─── Export CSV ──────────────────────────────────────────────────────

//   const handleExportCSV = () => {
//     const headers = ["ID", "Employee", "Shift", "Site", "Date", "Punch In", "Punch Out", "Hours", "Wage (₹)", "Status"];
//     const csvRows = filteredRows.map((row) => [
//       row.emp.id,
//       row.emp.name,
//       row.emp.shift,
//       row.emp.site,
//       row.date.format("DD MMM YYYY"),
//       row.punchIn ? formatPunchTime(row.punchIn) : "--",
//       row.punchOut ? formatPunchTime(row.punchOut) : "--",
//       row.hours.toFixed(1),
//       row.wage,
//       row.status,
//     ]);
//     const csvContent =
//       "data:text/csv;charset=utf-8," +
//       [headers.join(","), ...csvRows.map((r) => r.map((v) => `"${v}"`).join(","))].join("\n");
//     const link = document.createElement("a");
//     link.setAttribute("href", encodeURI(csvContent));
//     link.setAttribute(
//       "download",
//       `Daily_Wage_Register_${moment().format("DD_MMM_YYYY")}.csv`,
//     );
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   };

//   // ─── Table Columns ──────────────────────────────────────────────────

//   const columns: TableColumn<IWageRow>[] = [
//     {
//       key: "employee",
//       header: "Employee",
//       render: (row) => {
//         const initials = row.emp.name
//           .split(" ")
//           .map((n) => n[0])
//           .join("")
//           .slice(0, 2)
//           .toUpperCase();
//         const idx = parseInt(row.emp.id.replace(/\D/g, ""), 10) || 0;
//         return (
//           <div className="flex items-center gap-3">
//             <div
//               className={`w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold shrink-0 ${avatarPalette[idx % avatarPalette.length]}`}
//             >
//               {initials}
//             </div>
//             <div>
//               <p className="font-semibold text-slate-800 leading-tight">{row.emp.name}</p>
//               <p className="text-xs text-slate-400">{row.emp.id}</p>
//             </div>
//           </div>
//         );
//       },
//     },
//     {
//       key: "shift",
//       header: "Shift",
//       render: (row) => {
//         // Optional: add a small dot with color
//         const shiftColors: Record<string, string> = {
//           Day: "bg-amber-400",
//           Night: "bg-indigo-600",
//           Afternoon: "bg-teal-500",
//         };
//         return (
//           <span className="inline-flex items-center gap-1.5">
//             <span className={`w-2 h-2 rounded-full ${shiftColors[row.emp.shift] || "bg-slate-400"}`} />
//             {row.emp.shift}
//           </span>
//         );
//       },
//     },
//     {
//       key: "site",
//       header: "Site",
//       render: (row) => <span className="text-slate-600">{row.emp.site}</span>,
//     },
//     {
//       key: "date",
//       header: "Date",
//       render: (row) => <span className="text-slate-600 whitespace-nowrap">{row.date.format("DD MMM YYYY")}</span>,
//     },
//     {
//       key: "punchIn",
//       header: "Punch In",
//       render: (row) => (
//         <span className="text-slate-600 whitespace-nowrap">
//           {row.punchIn ? formatPunchTime(row.punchIn) : "—"}
//         </span>
//       ),
//     },
//     {
//       key: "punchOut",
//       header: "Punch Out",
//       render: (row) => (
//         <span className="text-slate-600 whitespace-nowrap">
//           {row.punchOut ? formatPunchTime(row.punchOut) : "—"}
//         </span>
//       ),
//     },
//     {
//       key: "hours",
//       header: "Hours",
//       render: (row) => <span className="text-slate-600 whitespace-nowrap">{row.hours.toFixed(1)}h</span>,
//     },
//     {
//       key: "wage",
//       header: "Wage (₹)",
//       render: (row) => <span className="font-semibold text-indigo-600">₹{row.wage.toLocaleString()}</span>,
//     },
//     {
//       key: "status",
//       header: "Status",
//       render: (row) => (
//         <span
//           className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-semibold whitespace-nowrap ${statusStyles[row.status]}`}
//         >
//           {row.status}
//         </span>
//       ),
//     },
//   ];

//   // ─── Render ──────────────────────────────────────────────────────────

//   // Additional filters: Site dropdown + Shift dropdown
//   const siteOptions = [
//     { label: "All Sites", value: "All" },
//     ...Array.from(new Set(initialEmployeesData.map((e) => e.site))).map((site) => ({
//       label: site,
//       value: site,
//     })),
//   ];

//   const shiftOptions = [
//     { label: "All Shifts", value: "All" },
//     ...Array.from(new Set(initialEmployeesData.map((e) => e.shift))).map((shift) => ({
//       label: shift,
//       value: shift,
//     })),
//   ];

//   const additionalFilters = (
//     <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
//       <div className="flex items-center gap-1">
//         <label className="text-xs text-slate-400 font-medium sr-only sm:not-sr-only">Site:</label>
//         <select
//           value={filter.site || "All"}
//           onChange={(e) => handleFilterChange(e.target.value, "site")}
//           className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer w-full sm:w-auto"
//         >
//           {siteOptions.map((opt) => (
//             <option key={opt.value} value={opt.value}>{opt.label}</option>
//           ))}
//         </select>
//       </div>
//       <div className="flex items-center gap-1">
//         <label className="text-xs text-slate-400 font-medium sr-only sm:not-sr-only">Shift:</label>
//         <select
//           value={filter.shift || "All"}
//           onChange={(e) => handleFilterChange(e.target.value, "shift")}
//           className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer w-full sm:w-auto"
//         >
//           {shiftOptions.map((opt) => (
//             <option key={opt.value} value={opt.value}>{opt.label}</option>
//           ))}
//         </select>
//       </div>
//     </div>
//   );

//   return (
//       <div className="space-y-6">
//         {/* Header */}
//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
//           <MainHeading
//             title="Daily Wage Register"
//             actions={
//               <Button onClick={handleExportCSV} disabled={filteredRows.length === 0} className="gap-2">
//                 <Download size={16} /> Export
//               </Button>
//             }
//           />
//         </div>


//         {/* Filter + Table */}
//         <div className="bg-white border border-slate-200/70 rounded-xl shadow-sm p-4 sm:p-5 space-y-4">
//           <CommonFilter
//             searchValue={filter.search || ""}
//             onSearchChange={handleSearchChange}
//             searchPlaceholder="Search employee..."
//             value={filter}
//             onChange={handleFilterChange}
//             filterOptions={statusFilterOptions}
//             filterName="filter"
//             filterPlaceholder="Status"
//             sortOptions={sortOptions}
//             sortName="sort"
//             sortPlaceholder="Sort by: Date"
//             startDate={filter.startDate}
//             endDate={filter.endDate}
//             onDateRangeChange={handleDateRangeChange}
//             additionalFilters={additionalFilters}
//           />
//           <CommonTable data={pagedRows} columns={columns} loading={false} stickyColumns={2} />
//           <TablePagination
//             paginationData={tablePaginationData}
//             setPaginationData={setPaginationData}
//             handleChangePageSize={handleChangePageSize}
//             isLoading={false}
//           />
//         </div>
//       </div>
//   );
// };

// export default WageReport;

import React, { useState, useMemo } from "react";
import moment from "moment";
import { Download, Users, Clock, DollarSign, CheckCircle2 } from "lucide-react";
import Layout from "../../components/layout/Layout";
import { Button } from "../../components/ui/button";
import MainHeading from "../../components/common/MainHeading";
import CommonFilter, { type IFilter } from "../../components/common/CommonFilter";
import CommonTable, { type TableColumn } from "../../components/common/CommonTable";
import TablePagination from "../../components/common/TablePagination";
import type { IPageInfo } from "@/interface/common.interface";
import { ShiftBadge, StatusBadge, SiteLabel, AvatarCell } from "../../components/common/Badge";

// ─── Types ──────────────────────────────────────────────────────────────

interface IPunchData {
  punchIn?: string;
  punchOut?: string;
}

interface IEmployeeDailyWage {
  id: string;
  name: string;
  shift: string; // Day, Night, or Afternoon
  site: string;
  hourlyRate: number;
  days: Record<number, IPunchData>;
}

type WageStatus = "Paid" | "Due" | "Absent";

interface IWageRow {
  key: string;
  emp: IEmployeeDailyWage;
  date: moment.Moment;
  dayNum: number;
  punchIn?: string;
  punchOut?: string;
  hours: number;
  wage: number;
  status: WageStatus;
}

// ─── Helpers ─────────────────────────────────────────────────────────────

const calculateHours = (punchIn?: string, punchOut?: string): number => {
  if (!punchIn || !punchOut) return 0;
  const start = moment(punchIn, "hh:mm A");
  const end = moment(punchOut, "hh:mm A");
  const duration = moment.duration(end.diff(start));
  const hours = duration.asHours();
  return Math.round(hours * 10) / 10;
};

const formatPunchTime = (time?: string): string => {
  if (!time) return "";
  return moment(time, "hh:mm A").format("HH:mm");
};

const getStatus = (punchIn?: string, punchOut?: string): WageStatus => {
  if (punchIn && punchOut) return "Paid";
  if (punchIn || punchOut) return "Due";
  return "Absent";
};

// ─── Mock Data ──────────────────────────────────────────────────────────

const initialEmployeesData: IEmployeeDailyWage[] = [
  {
    id: "E001",
    name: "Rajesh Kumar",
    shift: "Day",
    site: "Site A",
    hourlyRate: 85,
    days: {
      1: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
      2: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      3: { punchIn: "7:45 AM" },
      4: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
      5: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
      6: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
      7: {},
      8: { punchIn: "8:10 AM", punchOut: "4:20 PM" },
      9: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
      10: { punchIn: "8:00 AM" },
      11: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
      12: { punchIn: "7:50 AM", punchOut: "4:10 PM" },
      13: {},
      14: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
      15: { punchIn: "8:00 AM", punchOut: "4:30 PM" },
    },
  },
  {
    id: "E002",
    name: "Sunita Devi",
    shift: "Afternoon",
    site: "Site B",
    hourlyRate: 65,
    days: {
      1: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
      2: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
      3: {},
      4: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
      5: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
      6: { punchIn: "8:30 AM" },
      7: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
      8: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
      9: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
      10: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
      11: {},
      12: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
      13: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
      14: { punchIn: "8:30 AM", punchOut: "4:00 PM" },
      15: { punchIn: "8:30 AM" },
    },
  },
  {
    id: "E003",
    name: "Arvind Singh",
    shift: "Night",
    site: "Site A",
    hourlyRate: 110,
    days: {
      1: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      2: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      3: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      4: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      5: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      6: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      7: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      8: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      9: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      10: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      11: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      12: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      13: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      14: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
      15: { punchIn: "7:00 AM", punchOut: "3:30 PM" },
    },
  },
  {
    id: "E004",
    name: "Priya Sharma",
    shift: "Day",
    site: "Site C",
    hourlyRate: 95,
    days: {
      1: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      2: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      3: {},
      4: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      5: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      6: {},
      7: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      8: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      9: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      10: { punchIn: "8:15 AM" },
      11: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      12: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      13: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      14: { punchIn: "8:15 AM", punchOut: "4:45 PM" },
      15: {},
    },
  },
  {
    id: "E005",
    name: "Vikram Patel",
    shift: "Afternoon",
    site: "Site B",
    hourlyRate: 80,
    days: {
      1: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
      2: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
      3: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
      4: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
      5: {},
      6: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
      7: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
      8: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
      9: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
      10: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
      11: {},
      12: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
      13: { punchIn: "8:30 AM" },
      14: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
      15: { punchIn: "8:30 AM", punchOut: "5:00 PM" },
    },
  },
  {
    id: "E006",
    name: "Anita Reddy",
    shift: "Night",
    site: "Site C",
    hourlyRate: 60,
    days: {
      1: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
      2: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
      3: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
      4: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
      5: { punchIn: "9:00 AM" },
      6: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
      7: {},
      8: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
      9: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
      10: {},
      11: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
      12: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
      13: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
      14: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
      15: { punchIn: "9:00 AM", punchOut: "4:00 PM" },
    },
  },
  {
    id: "E007",
    name: "Manoj Kumar",
    shift: "Day",
    site: "Site A",
    hourlyRate: 100,
    days: {
      1: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      2: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      3: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      4: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      5: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      6: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      7: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      8: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      9: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      10: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      11: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      12: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      13: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      14: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
      15: { punchIn: "7:30 AM", punchOut: "4:30 PM" },
    },
  },
  {
    id: "E008",
    name: "Sneha Patel",
    shift: "Afternoon",
    site: "Site B",
    hourlyRate: 90,
    days: {
      1: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      2: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      3: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      4: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      5: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      6: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      7: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      8: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      9: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      10: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      11: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      12: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      13: {},
      14: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
      15: { punchIn: "8:00 AM", punchOut: "4:15 PM" },
    },
  },
  {
    id: "E009",
    name: "Ravi Singh",
    shift: "Night",
    site: "Site C",
    hourlyRate: 85,
    days: {
      1: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
      2: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
      3: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
      4: {},
      5: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
      6: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
      7: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
      8: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
      9: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
      10: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
      11: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
      12: { punchIn: "8:20 AM" },
      13: {},
      14: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
      15: { punchIn: "8:20 AM", punchOut: "4:50 PM" },
    },
  },
  {
    id: "E010",
    name: "Geeta Sharma",
    shift: "Day",
    site: "Site A",
    hourlyRate: 120,
    days: {
      1: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      2: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      3: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      4: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      5: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      6: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      7: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      8: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      9: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      10: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      11: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      12: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      13: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
      14: {},
      15: { punchIn: "7:15 AM", punchOut: "3:45 PM" },
    },
  },
];

// ─── Filter / Sort options ─────────────────────────────────────────────

const statusFilterOptions = [
  { label: "All", value: "" },
  { label: "Paid", value: "Paid" },
  { label: "Due", value: "Due" },
  { label: "Absent", value: "Absent" },
];

const sortOptions = [
  { label: "Employee", value: "name" },
  { label: "Date", value: "date" },
  { label: "Hours", value: "hours" },
  { label: "Wage", value: "wage" },
  { label: "Status", value: "status" },
  { label: "Shift", value: "shift" },
];

// ─── Component ──────────────────────────────────────────────────────────

const WageReport: React.FC = () => {
  const [filter, setFilter] = useState<IFilter>({
    search: "",
    filter: "", // status filter
    sort: "date",
    site: "All",
    shift: "All",
    startDate: moment().startOf("month").format("YYYY-MM-DD"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
  });

  const [paginationData, setPaginationData] = useState<IPageInfo>({
    currentPage: 1,
    pageSize: 10,
    total: 0,
    totalPages: 0,
  });

  // ─── Build flattened rows ─────────────────────────────────────────────

  const rows = useMemo(() => {
    const start = moment(filter.startDate);
    const end = moment(filter.endDate);
    const days: moment.Moment[] = [];
    const cursor = start.clone();
    while (cursor.isSameOrBefore(end, "day") && days.length < 62) {
      days.push(cursor.clone());
      cursor.add(1, "day");
    }

    const records: IWageRow[] = [];

    initialEmployeesData.forEach((emp) => {
      days.forEach((date) => {
        const dayNum = date.date();
        const dayData = emp.days[dayNum] || {};
        const hours = calculateHours(dayData.punchIn, dayData.punchOut);
        const wage = Math.round(hours * emp.hourlyRate);
        const status = getStatus(dayData.punchIn, dayData.punchOut);

        records.push({
          key: `${emp.id}-${date.format("YYYY-MM-DD")}`,
          emp,
          date,
          dayNum,
          punchIn: dayData.punchIn,
          punchOut: dayData.punchOut,
          hours,
          wage,
          status,
        });
      });
    });

    return records;
  }, [filter.startDate, filter.endDate]);

  // ─── Filter & Sort ──────────────────────────────────────────────────

  const filteredRows = useMemo(() => {
    const search = (filter.search || "").toLowerCase();
    const siteFilter = filter.site || "All";
    const shiftFilter = filter.shift || "All";

    let result = rows.filter((row) => {
      const matchesSearch =
        !search ||
        row.emp.name.toLowerCase().includes(search) ||
        row.emp.id.toLowerCase().includes(search);
      const matchesStatus = !filter.filter || row.status === filter.filter;
      const matchesSite = siteFilter === "All" || row.emp.site === siteFilter;
      const matchesShift = shiftFilter === "All" || row.emp.shift === shiftFilter;
      return matchesSearch && matchesStatus && matchesSite && matchesShift;
    });

    const sortKey = filter.sort || "date";
    result = [...result].sort((a, b) => {
      if (sortKey === "name") return a.emp.name.localeCompare(b.emp.name);
      if (sortKey === "date") return a.date.valueOf() - b.date.valueOf();
      if (sortKey === "hours") return b.hours - a.hours;
      if (sortKey === "wage") return b.wage - a.wage;
      if (sortKey === "status") return a.status.localeCompare(b.status);
      if (sortKey === "shift") return a.emp.shift.localeCompare(b.emp.shift);
      return 0;
    });

    return result;
  }, [rows, filter.search, filter.filter, filter.sort, filter.site, filter.shift]);

  // ─── Global Stats ──────────────────────────────────────────────────

  const globalStats = useMemo(() => {
    let totalHours = 0;
    let totalWage = 0;
    let paidDays = 0;
    let dueDays = 0;
    let absentDays = 0;

    filteredRows.forEach((row) => {
      if (row.status === "Paid") {
        paidDays++;
        totalHours += row.hours;
        totalWage += row.wage;
      } else if (row.status === "Due") {
        dueDays++;
        totalHours += row.hours;
        totalWage += row.wage;
      } else {
        absentDays++;
      }
    });

    return {
      employees: new Set(filteredRows.map((r) => r.emp.id)).size,
      hours: Math.round(totalHours * 10) / 10,
      paidDays,
      dueDays,
      payable: Math.round(totalWage),
    };
  }, [filteredRows]);

  // ─── Pagination ──────────────────────────────────────────────────────

  const totalPages = Math.max(1, Math.ceil(filteredRows.length / paginationData.pageSize));
  const currentPage = Math.min(paginationData.currentPage, totalPages);
  const pagedRows = filteredRows.slice(
    (currentPage - 1) * paginationData.pageSize,
    currentPage * paginationData.pageSize,
  );

  const tablePaginationData: IPageInfo = {
    ...paginationData,
    currentPage,
    total: filteredRows.length,
    totalPages,
  };

  // ─── Handlers ────────────────────────────────────────────────────────

  const handleSearchChange = (value: string) => {
    setFilter((prev) => ({ ...prev, search: value }));
    setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleFilterChange = (value: string, name: string) => {
    setFilter((prev) => ({ ...prev, [name]: value }));
    setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleDateRangeChange = (start: string, end: string) => {
    setFilter((prev) => ({
      ...prev,
      startDate: start || moment().startOf("month").format("YYYY-MM-DD"),
      endDate: end || moment().endOf("month").format("YYYY-MM-DD"),
    }));
    setPaginationData((prev) => ({ ...prev, currentPage: 1 }));
  };

  const handleChangePageSize = (value: number) => {
    setPaginationData((prev) => ({ ...prev, pageSize: value, currentPage: 1 }));
  };

  // ─── Export CSV ──────────────────────────────────────────────────────

  const handleExportCSV = () => {
    const headers = ["ID", "Employee", "Shift", "Site", "Date", "Punch In", "Punch Out", "Hours", "Wage (₹)", "Status"];
    const csvRows = filteredRows.map((row) => [
      row.emp.id,
      row.emp.name,
      row.emp.shift,
      row.emp.site,
      row.date.format("DD MMM YYYY"),
      row.punchIn ? formatPunchTime(row.punchIn) : "--",
      row.punchOut ? formatPunchTime(row.punchOut) : "--",
      row.hours.toFixed(1),
      row.wage,
      row.status,
    ]);
    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...csvRows.map((r) => r.map((v) => `"${v}"`).join(","))].join("\n");
    const link = document.createElement("a");
    link.setAttribute("href", encodeURI(csvContent));
    link.setAttribute("download", `Daily_Wage_Register_${moment().format("DD_MMM_YYYY")}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // ─── Table Columns ──────────────────────────────────────────────────
  // All badge-style cells (Shift / Status) and the Site cell now come
  // from the shared Badge component so this table matches every other
  // table in the app pixel-for-pixel.

  const columns: TableColumn<IWageRow>[] = [
    {
      key: "employee",
      header: "Employee",
      render: (row) => {
        const idx = parseInt(row.emp.id.replace(/\D/g, ""), 10) || 0;
        return <AvatarCell name={row.emp.name} subLabel={row.emp.id} paletteIndex={idx} />;
      },
    },
    {
      key: "shift",
      header: "Shift",
      render: (row) => <ShiftBadge shift={row.emp.shift} />,
    },
    {
      key: "site",
      header: "Site",
      render: (row) => <SiteLabel label={row.emp.site} />,
    },
    {
      key: "date",
      header: "Date",
      render: (row) => <span className="text-slate-600 whitespace-nowrap">{row.date.format("DD MMM YYYY")}</span>,
    },
    {
      key: "punchIn",
      header: "Punch In",
      render: (row) => (
        <span className="text-slate-600 whitespace-nowrap">
          {row.punchIn ? formatPunchTime(row.punchIn) : "—"}
        </span>
      ),
    },
    {
      key: "punchOut",
      header: "Punch Out",
      render: (row) => (
        <span className="text-slate-600 whitespace-nowrap">
          {row.punchOut ? formatPunchTime(row.punchOut) : "—"}
        </span>
      ),
    },
    {
      key: "hours",
      header: "Hours",
      render: (row) => <span className="text-slate-600 whitespace-nowrap">{row.hours.toFixed(1)}h</span>,
    },
    {
      key: "wage",
      header: "Wage (₹)",
      render: (row) => <span className="font-semibold text-indigo-600">₹{row.wage.toLocaleString()}</span>,
    },
    {
      key: "status",
      header: "Status",
      render: (row) => <StatusBadge status={row.status} />,
    },
  ];

  // ─── Render ──────────────────────────────────────────────────────────

  const siteOptions = [
    { label: "All Sites", value: "All" },
    ...Array.from(new Set(initialEmployeesData.map((e) => e.site))).map((site) => ({
      label: site,
      value: site,
    })),
  ];

  const shiftOptions = [
    { label: "All Shifts", value: "All" },
    ...Array.from(new Set(initialEmployeesData.map((e) => e.shift))).map((shift) => ({
      label: shift,
      value: shift,
    })),
  ];

  const additionalFilters = (
    <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto">
      <div className="flex items-center gap-1">
        <label className="text-xs text-slate-400 font-medium sr-only sm:not-sr-only">Site:</label>
        <select
          value={filter.site || "All"}
          onChange={(e) => handleFilterChange(e.target.value, "site")}
          className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer w-full sm:w-auto"
        >
          {siteOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
      <div className="flex items-center gap-1">
        <label className="text-xs text-slate-400 font-medium sr-only sm:not-sr-only">Shift:</label>
        <select
          value={filter.shift || "All"}
          onChange={(e) => handleFilterChange(e.target.value, "shift")}
          className="h-9 rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-primary cursor-pointer w-full sm:w-auto"
        >
          {shiftOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>{opt.label}</option>
          ))}
        </select>
      </div>
    </div>
  );

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <MainHeading
          title="Daily Wage Register"
          actions={
            <Button onClick={handleExportCSV} disabled={filteredRows.length === 0} className="gap-2">
              <Download size={16} /> Export
            </Button>
          }
        />
      </div>


      {/* Filter + Table */}
      <div className="bg-white border border-slate-200/70 rounded-xl shadow-sm p-4 sm:p-5 space-y-4">
        <CommonFilter
          searchValue={filter.search || ""}
          onSearchChange={handleSearchChange}
          searchPlaceholder="Search employee..."
          value={filter}
          onChange={handleFilterChange}
          filterOptions={statusFilterOptions}
          filterName="filter"
          filterPlaceholder="Status"
          sortOptions={sortOptions}
          sortName="sort"
          sortPlaceholder="Sort by: Date"
          startDate={filter.startDate}
          endDate={filter.endDate}
          onDateRangeChange={handleDateRangeChange}
          additionalFilters={additionalFilters}
        />
        <CommonTable data={pagedRows} columns={columns} loading={false} stickyColumns={2} />
        <TablePagination
          paginationData={tablePaginationData}
          setPaginationData={setPaginationData}
          handleChangePageSize={handleChangePageSize}
          isLoading={false}
        />
      </div>
    </div>
  );
};

export default WageReport;